import Renderer from './Renderer'

export default abstract class ColumnRenderer extends Renderer {
  /**
   * User needs to extends this class and provide
   * getColumns implementation
   */
  abstract getColumns(): any[]
}
